
import { useCallback, useEffect, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const FeatureFlagsDefaultValues = {
  exactReportAi: false,
  permanentShowAddInSuggetionTitles: false,
  projectJurisdictionSelectorCp1: false,
  showUiTestButton: false,
  shouldUseMockAnalysisResponse: false
};

const useFeatureFlags = () => {
  const flags = useFlags();
  const [mergedFlags, setMergedFlags] = useState(FeatureFlagsDefaultValues);

  useEffect(() => {
    setMergedFlags({ ...FeatureFlagsDefaultValues, ...flags });
  }, [flags]);

  const getFlag = useCallback((flagName: keyof typeof FeatureFlagsDefaultValues) => {
    if (mergedFlags[flagName] === null || mergedFlags[flagName] === undefined) {
      console.log(`Feature flag ${String(flagName)} is not defined`);
    }
    return mergedFlags[flagName];
  }, [mergedFlags]);

  return { getFlag };
};

export default useFeatureFlags;